import React, { useEffect } from "react";
import { Badge, Button, Col, Container, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  deleteServiceAdmin,
  listServicesAdmin,
} from "../../actions/serviceActions";
import { ADMIN_SERVICE_DELETE_RESET } from "../../constants/serviceConstants";
import Loader from "../../components/Loader";
import Message from "../../components/Message";

function formatLeadTime(days = 0) {
  const count = Number(days || 0);

  if (count <= 0) return "Same day";
  if (count === 1) return "1 day";
  return `${count} days`;
}

export default function AdminServicesScreen() {
  const dispatch = useDispatch();

  const adminList = useSelector((state) => state.adminServiceList);
  const { loading, error, services = [] } = adminList;

  const deleted = useSelector((state) => state.adminServiceDelete);
  const {
    success: successDelete,
    error: errorDelete,
    loading: loadingDelete,
  } = deleted;

  useEffect(() => {
    dispatch(listServicesAdmin());
  }, [dispatch, successDelete]);

  useEffect(() => {
    if (successDelete) {
      dispatch({ type: ADMIN_SERVICE_DELETE_RESET });
    }
  }, [dispatch, successDelete]);

  const deleteHandler = (id) => {
    if (window.confirm("Delete this service? It will be unpublished.")) {
      dispatch(deleteServiceAdmin(id));
    }
  };

  return (
    <Container className="py-4">
      <Row className="align-items-center g-3 mb-3">
        <Col>
          <h1>Admin • Services</h1>
          <div className="text-muted">
            Manage in-house services shown on /services.
          </div>
        </Col>

        <Col md="auto" className="d-flex gap-2 flex-wrap">
          <Link to="/admin/services/orders" className="btn btn-outline-dark">
            Service Orders
          </Link>
          <Link to="/admin/services/bookings" className="btn btn-outline-dark">
            Reservations
          </Link>
          <Link to="/admin/services/new" className="btn btn-dark">
            Create service
          </Link>
        </Col>
      </Row>

      {loadingDelete && <Message>Deleting service...</Message>}
      {errorDelete && <Message variant="danger">{errorDelete}</Message>}
      {error && <Message variant="danger">{error}</Message>}
      {loading && <Loader />}

      <Table striped bordered hover responsive className="align-middle">
        <thead>
          <tr>
            <th>Order</th>
            <th>Service</th>
            <th>Price</th>
            <th>Duration</th>
            <th>Lead Time</th>
            <th>Status</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>

        <tbody>
          {services.map((service) => (
            <tr
              key={service._id}
              style={service.isDeleted ? { opacity: 0.6 } : undefined}
            >
              <td>{service.order}</td>
              <td>
                <div className="fw-semibold">{service.name}</div>
                <div className="text-muted small">/{service.slug}</div>
              </td>
              <td>{service.priceLabel || "Price on request"}</td>
              <td>{service.durationMinutes || 30} min</td>
              <td>{formatLeadTime(service.leadTimeDays)}</td>
              <td>
                {service.isDeleted ? (
                  <Badge bg="secondary">Deleted</Badge>
                ) : service.isPublished ? (
                  <Badge bg="success">Published</Badge>
                ) : (
                  <Badge bg="warning" text="dark">
                    Unpublished
                  </Badge>
                )}
              </td>
              <td>
                <Link to={`/admin/services/${service._id}/edit`}>Edit</Link>
              </td>
              <td>
                <Button
                  variant="outline-danger"
                  size="sm"
                  disabled={service.isDeleted}
                  onClick={() => deleteHandler(service._id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}

          {services.length === 0 && !loading ? (
            <tr>
              <td colSpan={8} className="text-center text-muted">
                No services found.
              </td>
            </tr>
          ) : null}
        </tbody>
      </Table>
    </Container>
  );
}
